import {ACCOUNT} from '../constants';

export const registerAccount = (accountData) => {
    return {
        type: ACCOUNT.REGISTER_ACCOUNT,
        accountData: accountData
    }
}

export const registerAccountLoad = () => {
    return {
        type: ACCOUNT.REGISTER_ACCOUNT_LOAD
    }
}

export const registerAccountSuccess = () => {
    return {
        type: ACCOUNT.REGISTER_ACCOUNT_SUCCESS
    }
}

export const registerAccountFail = error => {
    return {
        type: ACCOUNT.REGISTER_ACCOUNT_FAIL,
        error: error
    }
}